import { EthenaTooltip } from '@ethena/shared-ui/src/components/EthenaTooltip'
import { InfoIcon } from '@ethena/shared-ui/src/components/InfoIcon'
import Placeholder from '@ethena/shared-ui/src/components/Placeholder'
import Image from 'next/image'

export const Stat = ({
  image,
  title,
  tooltip,
  value,
}: {
  image: string
  title: string
  value: string | undefined
  tooltip?: string
}) => {
  return (
    <article className="flex flex-col items-center justify-center">
      <Placeholder isLoading={!value} classes="w-[138px] h-[60px] sm:w-[180px] sm:h-[52px] mb-2">
        <p className="text-[40px] sm:text-[40px] font-semibold gradient-text">{value}</p>
      </Placeholder>
      <div className="flex items-center gap-2.5">
        <Image src={image} alt={title} width={20} height={20} className="h-5 w-5" />
        <h2 className="text-text-accent text-xs font-medium uppercase whitespace-nowrap font-inter">{title}</h2>
        {tooltip && (
          <EthenaTooltip content={tooltip}>
            <InfoIcon className="w-4 h-4 text-text-muted" />
          </EthenaTooltip>
        )}
      </div>
    </article>
  )
}
